<template>
  <div>
    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    >
      <template #start>
        <!--<el-form-item>
           <el-dropdown>
            <el-button type="primary">
              车队长<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in menu" :key="item.fleet">{{ item.name }}</el-dropdown-item>
              
            </el-dropdown-menu>
          </el-dropdown> -->
        <!-- <el-select v-model="value" placeholder="请选择车队长">
            <el-option
              v-for="item in menu"
              :key="item.fleet"
              :label="item.name"
              :value="item.fleet"
            >
            </el-option>
          </el-select> 
        </el-form-item>-->
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table
      ref="table"
      :tableHeight="tableHeight"
      :tableData="tableData"
      :cols="cols"
      :btns="btns"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "driver",
      formInline: {
        iswork: 1,
      },
      formCtrl: [
        // {
        //   label: "车队长",
        //   keyName: "fleet",
        //   placeholder: "选择车队长",
        //   type: "select",
        //   options: [],
        //   className:"carcap",
        // },
        {
          label: "姓名",
          keyName: "name",
          placeholder: "请填写姓名",
          type: "text",
        },
        /*{
          label: "性别：",
          keyName: "sex",
          placeholder: "请选择性别",
          type: "select",
          options: [
            { label: "男", value: "男" },
            { label: "女", value: "女" },
          ],
        },
        {
          label: "出生年月",
          keyName: "birthday",
          placeholder: "请选择出生年月",
          type: "date",
        },*/
      ],
      formCtrl0: [
        {
          label: "姓名",
          keyName: "name",
          placeholder: "请填写姓名",
          type: "text",
        },
      ],
      formCtrl1: [
        {
          label: "押金状态：",
          keyName: "deposit_status",
          placeholder: "请选择押金状态",
          type: "select",
          options: [
            { label: "全部", value: null },
            { label: "未扣除", value: 1 },
            { label: "已扣除", value: 2 },
            { label: "已归还", value: 3 },
          ],
        },
      ],
      cols: [
        // { prop: "fleetname", label: "车队长" },
        { prop: "name", label: "姓名" },
        { prop: "sex", label: "性别" },
        //{ prop: "age", label: "年龄" },
        { prop: "contacttel", label: "联系方式" },
        { prop: "nation", label: "民族" },
        { prop: "iswork", label: "状态" },
        { prop: "edu", label: "学历" },
        { prop: "deposit", label: "押金金额" },
        { prop: "deposit_status_str", label: "押金状态" },
      ],
      btns: [],
      btns0: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(`/staff/driverDetail?mode=view&id=${id}`);
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(`/staff/driverDetail?mode=edit&id=${id}`);
          },
        },
        {
          title: "证件管理",
          img: require("@/assets/img/icon_user_document.png"),
          unimg: require("@/assets/img/icon_user_document_hover.png"),
          cb: ({ id, name }) => {
            this.$router.push(
              `/staff/driverDocument?id=${id}&user_type=1&username=${name}`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
        {
          icon: "el-icon-link",
          title: "解绑",
          cb: ({ id }) => {
            this.$confirm("真的要解绑微信吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.unBind(id);
              })
              .catch(() => {
                console.log("取消");
              });
          },
        },
        {
          title: "签约管理",
          img: require("@/assets/img/icon_hy.png"),
          unimg: require("@/assets/img/icon_hy_hover.png"),
          cb: ({ userid }) => {
            this.$router.push(`/staff/driverHy?id=${userid}`);
          },
        },
      ],
      baseParams: ["fleet", "iswork"],
      menu: [],
      menuIndex: "",
      value: "",
    };
  },
  computed: {
    ...mapState(["store"]),
  },
  methods: {
    ...mapMutations(["setState"]),

    delParamsPackage(params) {
      params["headers"] = {
        "X-Method": "delete",
        "X-Module": "staff",
      };

      // console.log('params', { ...params })
    },

    dataObjHandler(v) {
      const o = {};
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          const ele = v[key];
          if (key == "deposit_status") {
            // console.log(ele)
            o["deposit_status_str"] = "未扣除";
            if (ele == 2) {
              o["deposit_status_str"] = "已扣除";
            } else if (ele == 3) {
              o["deposit_status_str"] = "已归还";
            }
          } else {
            o[key] = v[key];
          }
        }
      }
      return o;
    },
    addItem() {
      this.$router.push(`/staff/driverDetail`);
    },
    unBind(id) {
      const url = `${this.baseUrl}/uplre`;
      const params = {
        id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg == "success") {
            this.$message({
              type: "success",
              message: "解绑成功!",
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: "解绑失败，请稍后再试！",
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "解绑失败，请稍后重试！",
          });
        }
      );
    },
    setParams() {
      const { idx, iswork } = this.$route.params;
      const { fleet } = this.store;
      // console.log(idx, iswork, fleet)
      if (fleet && fleet.length) {
        this.formInline.fleet = fleet[idx - 1].id;
      }
      this.formInline.iswork = iswork;
      this.getList();

      this.$nextTick(() => {
        const { user_group_id } = this.user;
        const { iswork } = this.formInline;
        if ([2, 3, 4].includes(user_group_id) && iswork == 1) {
          this.btns = [this.btns0[0]];
        } else {
          this.btns = [...this.btns0];
        }
        // console.log(typeof iswork, iswork)
        if (["1", "2"].includes(iswork)) {
          this.formCtrl = [...this.formCtrl0, ...this.formCtrl1];
        } else {
          this.formCtrl = [...this.formCtrl0];
        }
        // console.log([...this.formCtrl])
      });
    },
    //车队长
    getCaptains() {
      this.loading = true;
      let url = `fixedpay/getfleet`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ fleet }) => {
          this.loading = false;
          this.menu = fleet.map((v, i) => {
            return {
              name: v.nickname,
              path: `/staff/driver/table/${i + 1}`,
              fleet: v.id,
            };
          });
          // if (this.menu.length) {
          //   this.formCtrl[0].options = fleet.map((v) => {
          //     return {
          //       label: v.nickname,
          //       value: v.id,
          //     };
          //   });
          // }
          this.$forceUpdate();
          const { idx } = this.$route.params;
          this.menuIndex = `/staff/driver/table/${idx}`;
          // console.log(this.setState);
          this.setState({
            key: "fleet",
            value: fleet,
          });
          // console.log(this.menuIndex)
          // console.log(this.menu)
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    onSearchItemChange({ key }) {
      // console.log(key)
      if (["fleet", "deposit_status"].includes(key)) {
        // console.log(this.formInline)
        this.getList();
      }
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setParams();
    },
  },
  created() {
    this.setParams();
  },
  mounted() {
    // this.getCaptains();
  },
};
</script>
<style lang="less" scoped>
/*.carcap .el-input__inner {
  width: 122px;
  color: #303133;
  border: 1px solid #F4F6F7;
  background-color: #F4F6F7;
}*/
// /deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
//     margin-right: 0px;
//     padding-right: 80px;
//     position: relative;
//     &::after {
//       position: absolute;
//       content: "";
//       right: 40px;
//       top: 6px;
//       width: 1px;
//       height: 28px;
//       overflow: hidden;
//       background-color: #EBEDF0;
//     }
// }
</style>
